"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecipeDepletionInputSchema = exports.RecipeDepletionItemSchema = exports.RecipeDepletionModifierSchema = exports.RecipeModifiersInputSchema = exports.RecipePosConfigInputSchema = exports.RecipePosConfigSchema = exports.RecipeChannelAvailabilitySchema = exports.RecipeModifierGroupSchema = exports.RecipeModifierOptionSchema = void 0;
const zod_1 = require("zod");
// ---------------------------------------------------------------------------
// Modifier Schemas
// ---------------------------------------------------------------------------
exports.RecipeModifierOptionSchema = zod_1.z.object({
    id: zod_1.z.string(),
    name: zod_1.z.string().min(1),
    price: zod_1.z.number().min(0),
    isDefault: zod_1.z.boolean().default(false),
    inventoryItemId: zod_1.z.string().optional(),
    quantity: zod_1.z.number().positive().optional(),
    unit: zod_1.z.string().optional(),
    behavior: zod_1.z.enum(['base', 'add', 'replace']),
    replacesIngredientId: zod_1.z.string().optional(),
    sortOrder: zod_1.z.number().int().min(0).default(0),
});
exports.RecipeModifierGroupSchema = zod_1.z.object({
    id: zod_1.z.string(),
    name: zod_1.z.string().min(1),
    required: zod_1.z.boolean(),
    minSelections: zod_1.z.number().int().min(0),
    maxSelections: zod_1.z.number().int().min(1),
    sortOrder: zod_1.z.number().int().min(0).default(0),
    options: zod_1.z.array(exports.RecipeModifierOptionSchema).min(1),
});
// ---------------------------------------------------------------------------
// POS Config Schemas
// ---------------------------------------------------------------------------
exports.RecipeChannelAvailabilitySchema = zod_1.z.object({
    retail: zod_1.z.boolean().optional(),
    online: zod_1.z.boolean().optional(),
    b2b: zod_1.z.boolean().optional(),
});
exports.RecipePosConfigSchema = zod_1.z.object({
    sellingPrices: zod_1.z.record(zod_1.z.string(), zod_1.z.number().min(0)),
    posCategoryId: zod_1.z.string().optional(),
    channelAvailability: exports.RecipeChannelAvailabilitySchema.optional(),
    posPublished: zod_1.z.boolean().default(false),
    sortOrder: zod_1.z.number().int().min(0).default(0),
});
// ---------------------------------------------------------------------------
// Input Schemas (request validation)
// ---------------------------------------------------------------------------
exports.RecipePosConfigInputSchema = exports.RecipePosConfigSchema;
exports.RecipeModifiersInputSchema = zod_1.z.object({
    modifiers: zod_1.z.array(exports.RecipeModifierGroupSchema),
});
// ---------------------------------------------------------------------------
// Depletion Schemas
// ---------------------------------------------------------------------------
exports.RecipeDepletionModifierSchema = zod_1.z.object({
    groupId: zod_1.z.string(),
    optionIds: zod_1.z.array(zod_1.z.string()),
});
exports.RecipeDepletionItemSchema = zod_1.z.object({
    recipeId: zod_1.z.string(),
    sizeId: zod_1.z.string(),
    quantity: zod_1.z.number().int().positive(),
    selectedModifiers: zod_1.z.array(exports.RecipeDepletionModifierSchema).default([]),
});
exports.RecipeDepletionInputSchema = zod_1.z.object({
    saleId: zod_1.z.string(),
    terminalId: zod_1.z.string(),
    items: zod_1.z.array(exports.RecipeDepletionItemSchema).min(1),
});
//# sourceMappingURL=recipe.schema.js.map